import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Sidebar from "../CommonComponents/Sidebar";
import MainContent from "./MerchantComponents/MainContent";
import AccumulativeMerchantRequestContainer from "../AccumulativeRequest/AccumulativeMerchantRequestContainer";
import { FaBars, FaTimes } from "react-icons/fa";
import RollIdPrompt from "../CommonComponents/RollIdPrompt";
import { RollIdProvider } from "../CommonComponents/RollIdContext";
import Tabs from "../CommonComponents/Tabs";

const Merchant = () => {
  const navigate = useNavigate();
  const { userType } = useParams();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [rollId, setRollId] = useState("");
  const [reload, setReload] = useState(0);
  const [activeRequest, setActiveRequest] = useState(null);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleRollIdSubmit = (id) => {
    setRollId(id);
  };

  const handleRequestToggle = (requestType) => {
    setActiveRequest(requestType);
  };

  useEffect(() => {
    let userTypeStorage = localStorage.getItem("user_Type");
    if (!userType || (userType !== "hgo" && userType !== "monazam")) {
      navigate("/");
    } else if (userType.toLowerCase() !== userTypeStorage.toLowerCase()) {
      navigate("/error_page");
    }
  }, [userType, navigate]);

  const renderContent = () => {
    if (activeRequest === "accumulative-merchant") {
      return <AccumulativeMerchantRequestContainer />;
    }
    return <MainContent reload={reload} />;
  };

  return (
    <RollIdProvider>
      <div className="dashboard-layout d-flex">
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          setReload={setReload}
          reload={reload}
          onRequestToggle={handleRequestToggle}
          activeRequest={activeRequest}
        />
        <div className={`main-content ${isSidebarOpen ? "blurred" : ""}`}>
          <div className="d-md-none d-flex align-items-center sidebar-logo-bg py-3 px-1">
            <button className="btn" onClick={toggleSidebar}>
              {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
            <img
              src="/assets/logo.png"
              alt="Logo"
              className="img-fluid logo pe-5 logo-height"
            />
          </div>

          <RollIdPrompt onRollIdSubmit={handleRollIdSubmit} />
          <div className="me-3 mt-3">
            <Tabs />
          </div>
          {renderContent()}
        </div>
      </div>
    </RollIdProvider>
  );
};

export default Merchant;
